export const readOnly = {
  backgroundColor: 'background.quiet',
  cursor: 'default', // important to indicate user selection is not allowed, but not explicitly disallowed
  color: 'text.quiet',
};
